// Persist only a digest and a random key, never names, phones or cart contents.
// sessionStorage survives reloads and Turbo visits within the same tab.
const attempts = new Map()
const TTL = 24 * 60 * 60 * 1000

export async function checkoutAttempt(scope, payload) {
  const bytes = new TextEncoder().encode(JSON.stringify(payload))
  const digest = await crypto.subtle.digest("SHA-256", bytes)
  const signature = Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, "0")).join("")
  const storageKey = `bookmania.checkout.${scope}`
  let attempt = attempts.get(storageKey)
  try { attempt = JSON.parse(sessionStorage.getItem(storageKey)) || attempt } catch { /* Storage unavailable. */ }
  if (!attempt || attempt.signature !== signature || attempt.expiresAt <= Date.now()) {
    attempt = { signature, key: crypto.randomUUID(), expiresAt: Date.now() + TTL }
  }
  attempts.set(storageKey, attempt)
  try { sessionStorage.setItem(storageKey, JSON.stringify(attempt)) } catch { /* Keep the in-memory retry. */ }
  return attempt.key
}

export function clearCheckoutAttempt(scope) {
  const storageKey = `bookmania.checkout.${scope}`
  attempts.delete(storageKey)
  try { sessionStorage.removeItem(storageKey) } catch { /* Storage unavailable. */ }
}
